import { render, staticRenderFns } from "./MessagesNotUnderstood.vue?vue&type=template&id=0c22bab0&scoped=true"
import script from "./MessagesNotUnderstood.vue?vue&type=script&lang=js"
export * from "./MessagesNotUnderstood.vue?vue&type=script&lang=js"
import style0 from "./MessagesNotUnderstood.vue?vue&type=style&index=0&id=0c22bab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22bab0",
  null
  
)

export default component.exports